var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"bodycap"}),_c('h1',[_vm._v("Esta es la pagina de areas")]),_c('b-alert',{attrs:{"variant":"success","show":""}},[_vm._v("Estamos configurando esta seccion")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }